export default function permCheck(user, permissions) {
  if (!permissions) return true;
  for (let i = 0; i < user.roles.length; i++) { // eslint-disable-line no-plusplus
    const role = user.roles[i];
    for (let j = 0; j < role.permissions.length; j++) { // eslint-disable-line no-plusplus
      const perm = role.permissions[j];

      if (permissions.includes(perm.name)) {
        return true;
      }
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/util/permCheck.js